import React from "react";
import { useNavigate } from "react-router-dom";
import {
  reactivateCampaign,
  closeCampaign,
} from "../../../utils/campaignViewActions";

/**
 * PausedActions — Reactivate or close a paused campaign
 * Backend: update-campaign-status (superAdmin.controller.js:1428)
 */
const PausedActions = ({ campaign, campaignId, canEdit }) => {
  const navigate = useNavigate();
  const resolvedCampaignId = campaignId || campaign?.data?.[0]?.id;

  // QA 2026-07-28 F-1 (beyond the four handlers the report named): both of these
  // open a confirmation dialog, and the page-level loader was raised before it -
  // covering the Swal (z 1060 under z 99999) and swallowing the click. Neither
  // needs the loader: `confirmAction` renders SweetAlert's own inline spinner
  // across the network phase.
  const handleReactivate = async () => {
    const result = await reactivateCampaign(resolvedCampaignId);
    if (result.success && result.navigateTo) navigate(result.navigateTo);
  };

  const handleClose = async () => {
    const result = await closeCampaign(resolvedCampaignId);
    if (result.success && result.navigateTo) navigate(result.navigateTo);
  };

  return (
    <div className="left">
      <h1 className="title">Campaign Actions (Paused)</h1>
      {/* QA 2026-09-07 (F22): writes need the queue's :Edit grant. A pending
          re-review (isForAdminReview 1) is decided from For Review; the API now
          refuses to reactivate over it (409 pending_review). */}
      {canEdit !== false && (
      <div style={{ display: "flex", gap: "10px", marginTop: "10px", marginBottom: "16px" }}>
        {Number(campaign?.data?.[0]?.isForAdminReview) === 1 ? (
          <p style={{ color: "#666", fontStyle: "italic" }}>
            This campaign has edits awaiting review. Decide them from the For Review queue before reactivating it.
          </p>
        ) : (
          <button className="approveButton" onClick={handleReactivate}>
            Reactivate Campaign
          </button>
        )}
        <button className="approveButton" onClick={handleClose} style={{ background: "#d33" }}>
          Close Campaign
        </button>
      </div>
      )}
    </div>
  );
};

export default PausedActions;
